import { render, staticRenderFns } from "./Bsr_d.vue?vue&type=template&id=a320fe5c&scoped=true"
import script from "./Bsr_d.vue?vue&type=script&lang=js"
export * from "./Bsr_d.vue?vue&type=script&lang=js"
import style0 from "./Bsr_d.vue?vue&type=style&index=0&id=a320fe5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a320fe5c",
  null
  
)

export default component.exports